import React, { useState } from "react";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogTrigger,
} from "../components-shadcn/dialog";
import { ReactComponent as Share } from "../assets/share.svg";
import { ReactComponent as Close } from "../assets/close.svg";
import ButtomSave from "./ButtomSave";
import { useStore } from "../lib/store";
import { HandleShare } from "../lib/utils";

const ShareLink: React.FC = () => {
  const params = new URLSearchParams(window.location.search);
  const user_id = params.get("user");
  const { id_hubspot } = useStore();
  const { id_superlogica } = useStore();

  const [isOpen, setIsOpen] = useState(false);

  return (
    <Dialog open={isOpen}>
      <DialogTrigger onClick={() => setIsOpen(true)}>
        <Share className="w-[1.5rem] h-[1.5rem]" />
      </DialogTrigger>

      <DialogContent
        showCloseButton={false}
        className="bg-white-primary flex justify-center items-center flex-col"
      >
        <div className="w-[100%] flex justify-end">
          <DialogClose onClick={() => setIsOpen(false)}>
            <Close
              onClick={() => console.log("Clicou!")}
              className="w-[1rem] h-[1rem]"
            />
          </DialogClose>
        </div>
        <p className="text-blue-primary text-[1.2rem] font-[700] text-center">
          Link de acesso temporário{" "}
        </p>
        <p className="text-center">
          Copie o link temporário para dar acesso ao seu time financeiro.
        </p>
        <ButtomSave
          icon="share_white"
          theme="mediumgreen"
          onClick={() => {
            HandleShare(
              `https://financeiro.kinology.com.br/?sp=${id_superlogica}&hb=${id_hubspot}&user=${user_id}&el=${true}`
            );
            setIsOpen(false);
          }}
        >
          Compartilhar link
        </ButtomSave>
      </DialogContent>
    </Dialog>
  );
};

export default ShareLink;
